import Contains from 'assets/icons/filtration/contains.svg?react';
import Equals from 'assets/icons/filtration/equals.svg?react';
import In from 'assets/icons/filtration/in.svg?react';
import Less from 'assets/icons/filtration/less.svg?react';
import LessOrEquals from 'assets/icons/filtration/lessOrEquals.svg?react';
import More from 'assets/icons/filtration/more.svg?react';
import MoreOrEquals from 'assets/icons/filtration/moreOrEquals.svg?react';
import NotContains from 'assets/icons/filtration/notContains.svg?react';
import NotEquals from 'assets/icons/filtration/notEquals.svg?react';
import NotIn from 'assets/icons/filtration/notIn.svg?react';
import Range from 'assets/icons/filtration/range.svg?react';

export const FILTER_OPERATIONS_MAP = {
  Contains,
  Equals,
  In,
  Less,
  LessOrEquals,
  More,
  MoreOrEquals,
  NotContains,
  NotEquals,
  NotIn,
  Range,
};
